// System Logs State

export default {
  logsList: [],
  logInfo: {}
}
